import { render, staticRenderFns } from "./Typographic.vue?vue&type=template&id=6549dc74&scoped=true"
import script from "./Typographic.vue?vue&type=script&lang=ts"
export * from "./Typographic.vue?vue&type=script&lang=ts"
import style0 from "./Typographic.vue?vue&type=style&index=0&id=6549dc74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6549dc74",
  null
  
)

export default component.exports